module.exports = __webpack_public_path__ + "img/b8476b5.svg";